import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

// Bonus / additional compensation APIs (Point 17, Mudassir Jun-19).
const BonusService = {
  // Manager: recommend a bonus for a direct report (status -> Recommended).
  recommend: async (payload) => {
    const response = await axiosInstance.post(API.bonus.recommend, payload);
    return response.data;
  },

  // HR/Admin: create an already-approved bonus, e.g. a signing bonus
  // (status -> Approved).
  create: async (payload) => {
    const response = await axiosInstance.post(API.bonus.create, payload);
    return response.data;
  },

  // HR/Admin: approve or reject a recommended bonus. payload = { isApproved, remarks }.
  review: async (bonusId, payload) => {
    const response = await axiosInstance.put(API.bonus.review(bonusId), payload);
    return response.data;
  },

  // HR/Admin: pending recommendation queue.
  getPending: async () => {
    const response = await axiosInstance.get(API.bonus.pending);
    return Array.isArray(response.data) ? response.data : [];
  },

  // HR/Admin: one employee's bonus history.
  getByEmployee: async (employeeId) => {
    const response = await axiosInstance.get(API.bonus.getByEmployee(employeeId));
    return Array.isArray(response.data) ? response.data : [];
  },

  // Employee: my own bonus history (read-only).
  getMine: async () => {
    const response = await axiosInstance.get(API.bonus.me);
    return Array.isArray(response.data) ? response.data : [];
  },

  // HR/Admin: all bonuses across the company. Optional status filter
  // (Recommended | Approved | Rejected | Paid). Mudassir Jun-21.
  getAll: async (status) => {
    const response = await axiosInstance.get(API.bonus.all(status));
    return Array.isArray(response.data) ? response.data : [];
  },
};

export default BonusService;
